import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05b81541"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-2",
  class: "page-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-box" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "100%",
    height: "100%",
    src: "https://www.youtube.com/embed/dvQ2bdAoaeg",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  })
], -1))

import ResponsiveImage from '../responsive-image.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 2096,
      "image-w": 3840,
      "mobile-image-h": 1380,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
    _hoisted_2
  ]))
}
}

})